import React from 'react';
import {Outlet} from "react-router-dom";
import {Layout} from 'antd';

const {Content} = Layout;

const Auth = () => {
    return (
        <Layout style={{height: '100vh'}}>
            <Content className="auth-content-area">
                <Outlet/>
            </Content>
        </Layout>
    );
};

export default Auth;
